import React from 'react';
import './Header.scss';
import Hamburger from '../HamburgerMenu/HamburgerMenu';
import { Link } from "react-router-dom";

const token = localStorage.getItem("token")

const Header = () => {
    return (
        <div className="header">
             <div className="header__title-container" style={!token ? {justifyContent: "center"} : {}}>
                 <Link to="/menu" className="header__link">
                    <p className="header__title">
                        <span className="header__food">Food</span>
                        <span className="header__r">r</span>
                    </p>
                </Link>
                {token !== null && <div className="header__menu-container">
                <Hamburger />
            </div>}
            </div>
           
        </div>
    );
};

export default Header;